import Tab from './Tabs';

export default Tab;
